/* Kalon round 5: product-card photo slider. Works with cards loaded later (filters, pagination). */
(() => {
  const sync = (track) => {
    const wrap = track.closest('.kc-slider');
    if (!wrap) return;
    const count = track.children.length;
    const index = Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
    wrap.querySelectorAll('.kc-dot').forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    const prev = wrap.querySelector('.kc-arrow--prev');
    const next = wrap.querySelector('.kc-arrow--next');
    if (prev) prev.disabled = index <= 0;
    if (next) next.disabled = index >= count - 1;
  };

  document.addEventListener('scroll', (event) => {
    const track = event.target;
    if (!(track instanceof Element) || !track.classList.contains('kc-track')) return;
    sync(track);
  }, { capture: true, passive: true });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.kc-arrow');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const track = button.closest('.kc-slider')?.querySelector('.kc-track');
    if (!track) return;
    const direction = button.classList.contains('kc-arrow--prev') ? -1 : 1;
    track.scrollBy({ left: direction * track.clientWidth });
  });
})();
